import { getCurrentInstance } from 'vue'

export const useSanitize = () => {
  // @ts-expect-error sanitize is injected via a plugin
  const sanitize = getCurrentInstance()?.proxy?.$sanitize as (input: string) => string

  if (!sanitize) {
    throw new Error('Sanitize function is not available in the current instance.')
  }

  return { sanitize }
}
